const PRIMARY_VALUES = new Set([
  "__done__",
  "__confirm__",
  "__repeat__",
  "__yes__",
  "__use_default__",
]);

const GHOST_ACTIONS = new Set(["skip", "toggle_allergens"]);

export const chipVariant = (chip, stepId) => {
  if (PRIMARY_VALUES.has(chip.value) || chip.action === "confirm") return "primary";
  if (stepId === "done" && chip.action === "restart") return "primary";
  if (GHOST_ACTIONS.has(chip.action)) return "ghost";
  return "";
};

export const isToggleChip = (chip, multi) =>
  multi &&
  chip.value !== "__done__" &&
  chip.action !== "toggle_allergens" &&
  chip.action !== "skip";

export const hintText = (multiMax) =>
  multiMax && multiMax > 1 ? `Choose up to ${multiMax}` : "Choose any";
